module.exports = __webpack_public_path__ + "img/envelope_fill.5a684e8c.svg";